import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-select-textile-model',
  templateUrl: './select-textile-model.component.html',
  styleUrls: ['./select-textile-model.component.css']
})
export class SelectTextileModelComponent implements OnInit {
    orderInternalNo;

    orderLineKeyno;

    public searchTextButtons: FormButton[] = [
        { id: 'search', icon: 'fas fa-search', type: 'primary', onClick: () => this.loadModels() }
    ];

    public setting?: Setting;

    public itemsListModels: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.orderInternalNo = this.stateService.getStateParams()['order_internal_no'];
        this.orderLineKeyno = this.stateService.getStateParams()['orderline_keyno'];
    }

    private async loadSetting() {
        if (!!this.orderInternalNo && !!this.orderLineKeyno) {
            this.setting = (await this.datatask.Post(1516, {
                order_internal_no: this.orderInternalNo,
                orderline_keyno: this.orderLineKeyno
            }))[0];
        }
    }

    private async loadModels() {
        if (!this.setting) return;

        return this.itemsListModels = await this.datatask.Post(1517, this.setting);
    }

    public searchItems() {
        this.loadModels();
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'searchtext':
                if (this.setting.searchtext === '') this.loadModels();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadModels();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    order_internal_no: string;
    orderline_keyno: string;
    searchtext: string;
}
